<template>
	<div v-if="!hasFlash">
		<div class="ui negative attached message">
			<h4>POMEMBNO OBVESTILO!</h4>
		</div>
		<div class="ui attached segment">
			<p>Pri zadnji posodobitvi brskalnikov je prišlo do sprememb, ki lahko vplivajo na delovanje portala iRokus.si. V primeru težav vam svetujemo, da preverite nastavitve brskalnika in jih po potrebi spremenite. 
			<p><a v-bind:href="route('flash')" target="_blank">Podrobnejša navodila</a></p>
		</div>
	</div>
</template>

<script>
    export default {
    	data() {
    		return {
    			hasFlash: false
    		}
    	},
        mounted() {
			try {
			  	var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
				if (fo) {
				   	this.hasFlash = true;
				}
			} catch (e) {
			  	if (navigator.mimeTypes && navigator.mimeTypes['application/x-shockwave-flash'] != undefined && navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
			    	this.hasFlash = true;
			  	}
			}
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/HasFlash.vue